
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import gorog from "../../assets/gorog.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function GorogMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Görög magyar fordító</title>
                <meta name='description' content="Ingyenes görög magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Görög magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/gorog-magyar-fordito" />
            </Helmet>
            <h1>Görög magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A görög nyelvről</h2>
                    <img src={gorog} alt="A görög zászló"></img>
                </div>

                <p>A görög nyelvet, amely egy ősi, gazdag történelemmel rendelkező nyelv, ma is mintegy 13 millióan beszélik, elsősorban Görögországban és Cipruson. Az Európai Unió is elismeri hivatalos nyelvként.</p>


                <p>A görög egy indoeurópai nyelv, és jelentős hatással van a nyugati civilizációra, számos terület, például az irodalom, a filozófia, a matematika és a tudomány alapjául szolgál. A nyelvnek három nagy történelmi szakasza van: Az ógörög, a koinéi görög és az újgörög.</p>


                <p>Az ógörög, az olyan nagy gondolkodók nyelve, mint Platón és Arisztotelész, összetettségéről és pontosságáról híres. Különböző dialektusai vannak, köztük az attikai, a jón és a dór nyelvjárások. Az ógörög nyelvtanban a főnevek, melléknevek és igék alakváltoztatással fejezik ki az esetet, nemet, számot és időt.</p>


                <p>A koiné görög az ógörög egyszerűsített formájaként alakult ki, és a keleti mediterrán térség lingua francája, valamint az Újszövetség nyelve lett. A korai kereszténység elterjedésében döntő szerepet játszott.</p>


                <p>A ma beszélt újgörög nyelv jelentős változásokon ment keresztül az ókori elődeihez képest. Egyszerűsített nyelvtani szerkezete van, kevesebb esettel és a főnevek deklinációjának egyszerűbb rendszerével. Ugyanakkor még mindig számos elemét őrzi gazdag történelmének.</p>


                <p>A görög írás a görög ábécével történik, amely 24 betűből áll. A görög ábécé számos betűje ismerős az angolul beszélők számára, mivel a tudományos és matematikai jelölésekben használják őket, mint például az alfa (α), a béta (β) és a gamma (γ).</p>


                <p>A görög szókincs számos nyelvre hatással volt, különösen olyan területeken, mint a tudomány, az orvostudomány és a filozófia. Számos görög szót átvettek az angol és más nyelvek, például a demokrácia, a filozófia és a matematika területén.</p>


                <p>A görög kiejtés a magyarhoz képest eltérő hangok miatt kihívást jelenthet. A görög nyelvnek vannak különálló magánhangzói és néhány mássalhangzó hangja, amelyek gyakorlást igényelhetnek a nem anyanyelvi beszélők számára.</p>
                <div className="sectionbottom">
                    <Link to="/magyar-gorog-fordito">Magyar görög fordító</Link>

                    <img src={gorog} alt="görög zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>


            </section>
        </>

    )
}

export default GorogMagyar;